var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.list.length == 0)?_c('span',[_vm._v("0.0000")]):_vm._e(),(_vm.ifOnceCurrency)?_c('span',[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.summ)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }